import React from "react";
import "./index.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Login from "./authentication/login";
import Signup from "./authentication/signup";
import SignupCream from "./authentication/signup-cream";
import Resetpwd from "./authentication/resetpwd";
import AppLayout from "./components/Layout/Layout";
import LoginForm from "./authentication/login";
import { getAuthToken } from "./helpers/userDetails";
import OrderCream from "./pages/OrderCream";

const RoutesWrapper = () => {
  const isLoggedIn = getAuthToken();
  const getHomePage = () => {
    if (!isLoggedIn) {
      return <LoginForm />;
    }
    return <></>;
  };

  return (
    <Router>
      {isLoggedIn && <AppLayout />}
      <Routes>
        <Route path="/" element={getHomePage()} />
        <Route path="/user-order-cream" element={<OrderCream />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignupCream />} />
        <Route path="/signup-cream" element={<SignupCream />} />
        <Route path="/forgotpassword" element={<Resetpwd />} />
      </Routes>
    </Router>
  );
};

export default RoutesWrapper;
